import {DatePipe, NgForOf, NgIf} from '@angular/common';
import {AfterViewInit, Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import {MatMenuModule} from '@angular/material/menu';
import {MatPaginator, MatPaginatorModule} from '@angular/material/paginator';
import {MatTableDataSource, MatTableModule} from '@angular/material/table';
import {MatTooltipModule} from '@angular/material/tooltip';
import {ActivatedRoute, RouterLink} from '@angular/router';
import {CustomizerSettingsService} from "../../../../customizer-settings/customizer-settings.service";
import {ApiService} from "../../../_services/api.service";
import {Endpoints} from "../../../endpoints";
import {DialogService} from "../../../_modal/dialog.service";
import {environment} from "../../../../../environments/environment";
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {MatError, MatFormField, MatLabel, MatSuffix} from "@angular/material/form-field";
import {MatInput, MatInputModule} from "@angular/material/input";
import {
    MatDatepicker,
    MatDatepickerInput,
    MatDatepickerModule,
    MatDatepickerToggle
} from "@angular/material/datepicker";
import {MatOption} from "@angular/material/autocomplete";
import {MatSelect} from "@angular/material/select";
import {OverlayContainer} from "@angular/cdk/overlay";
import {MatSort, MatSortModule} from "@angular/material/sort";
import {HandleErrorsService} from "../../../../services/handle-erros/handle.errors.service";
import {ClientsService} from "../../../../services/client-service/clients.service";
import {MatNativeDateModule} from "@angular/material/core";
import {MatCheckbox} from "@angular/material/checkbox";
import {ResultService} from "../../../../services/result-service/result.service";
import {ResultDTO} from "../../../_models/ResultDTO";
import {ParametreService} from "../../../../services/parametre-service/parametre.service";
import {ShortParametreDto} from "../../../_models/parametre-dtos";
import * as XLSX from "xlsx";
import {MatBadge} from "@angular/material/badge";
import {saveAs} from 'file-saver';
import {CommonResponse} from "../../../_models/Response";
import {of} from "rxjs";
import {SampleDTO} from "../../../_models/sampleDTO";
import { ParameterDTO } from '../../../_models/ParameterDTO';

@Component({
    selector: 'app-result-list',
    standalone: true,
    providers: [ParametreService, ApiService, Endpoints, DialogService, HandleErrorsService, ResultService, ClientsService],
    imports: [
        MatDatepickerModule,
        MatNativeDateModule,
        DatePipe,
        MatCardModule, MatMenuModule, MatButtonModule, RouterLink, MatTableModule, MatPaginatorModule, NgIf,
        MatTooltipModule, ReactiveFormsModule, MatFormField, MatLabel, MatError, MatInput, MatDatepicker,
        MatDatepickerInput, MatDatepickerToggle, MatSuffix, MatSortModule, MatInputModule, MatOption, MatSelect, NgForOf, MatCheckbox, FormsModule, MatBadge
    ],
    templateUrl: './result-list.component.html',
    styleUrl: './result-list.component.scss'
})
export class ResultListComponent implements OnInit, AfterViewInit {
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild('editModal') editModal: TemplateRef<ResultDTO>;
    @ViewChild('viewModal') viewModal: TemplateRef<ResultDTO>;
    editForm: FormGroup;
    form: FormGroup;
    parameter: ParameterDTO
    dataSource: MatTableDataSource<ResultDTO> = new MatTableDataSource<ResultDTO>();
    static searchValue: string = ''
    editedItems: Set<ResultDTO> = new Set<ResultDTO>()
    selectedItems: Set<ResultDTO> = new Set<ResultDTO>()
    selectAll: boolean = false
    loadingTable: boolean = false
    displayedColumns: string[] = [
        'select',
        'refAnalyse',
        'poids',
        'resultatBrute',
        'resultatFinale',
        'formule',
        'dateMesure',
        'valide',
        'creationDate',
        'updateDate',
        'action'
    ];
    result?: ResultDTO

    formules: any[] = [];      

    constructor(
        private resultService: ResultService,
        private handleErrors: HandleErrorsService,
        private parameterService: ParametreService,
        private dialogService: DialogService,
        private fb: FormBuilder,
        private route: ActivatedRoute,
        private modalService: NgbModal,
        public themeService: CustomizerSettingsService,
        private overlayContainer: OverlayContainer) {
        this.initializeEditForm();
        this.initializeCreateForm()
    }

    ngOnInit(): void {
        this.loadingTable = true
        this.fetchResults()
        this.getAllFormules();
    }

    ngAfterViewInit() {
        this.initializePaginatorAndSort();
    }

    private fetchResults() {
        this.loadingTable = true;
        this.resultService.findAll().subscribe({
            next: response => {
                console.log("Réponse reçue:", response);
                if (response.status) {
                    this.dataSource.data = response.data ?? [];
                } else {
                    console.warn("⚠ Aucune donnée trouvée.");
                }
            },
            error: err => {
                console.error("❌ Erreur lors de la récupération des résultats:", err);
                this.handleErrors.catchError(err);
            },
            complete: () => {
                this.loadingTable = false;
                console.log("✅ Chargement terminé.");
            }
        });
    }
    

    initializePaginatorAndSort() {
        this.overlayContainer.getContainerElement().style.zIndex = '2000'
        this.dataSource.filter = ResultListComponent.searchValue
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.sort.active = 'id';
        this.sort.direction = 'asc';


    }

    initializeEditForm() {
        this.editForm = this.fb.group({
            id: [''],
            analyseId: ['', Validators.required],
            refAnalyse: ['', Validators.required],
            poids: [0, Validators.required],
            resultatBrute: [0, Validators.required],
            resultatFinale: [0],
            dateMesure: [null, [Validators.required]],
            commentaire: [''],
            valide: [false],
            creationDate: [''],
            updateDate: [''],
            formule: ['', Validators.required] ,
            idcreatedBy: ['', Validators.required],
            namecreatedBy: ['']
        });
    }

    initializeCreateForm() {
        this.form = this.fb.group({
            name: ['', Validators.required],
            professional: ['', Validators.required],
            clientId: ['', Validators.required],
            details: ['', Validators.required],
            refAnalyse: ['', Validators.required],
            value1: ['', Validators.required],
            value2: ['', Validators.required],
            value3: ['', Validators.required],
            dateMesure: ['', Validators.required],
            commentaire: [''],
            valide: [false]
        });
    }
    openEditModal(element: ResultDTO) {
        console.log('Objet sélectionné pour édition :', element);
        this.fetchparameter(element.analyseId);

    
        this.editForm.patchValue(element);
        console.log('Formulaire après patch :', this.editForm.value);
        this.resultService.getFormule().subscribe({
          next: (formules) => {
            const selectedFormule = formules.find((f: { id: number; }) => f.id === element.formuleId); // Assurez-vous que formuleId existe dans element
            if (selectedFormule) {
              this.editForm.get('formule')?.setValue(selectedFormule.id);  // Si le contrôle est "formule", vous assignez l'id de la formule
              console.log('Formule ajoutée au formulaire:', selectedFormule);
            }
          },
          error: (err) => {
            console.error('Erreur lors de la récupération des formules:', err);
          }
        });
        this.modalService.open(this.editModal, { ariaLabelledBy: 'modal-basic-title', size: 'xl' });

    }
    openImportModal(importModal: any) {
        this.modalService.open(importModal, {ariaLabelledBy: 'modal-basic-title', size: 'lg'})
    }

    openViewModel(element: ResultDTO) {
        this.result = element
        this.fetchparameter(this.result.analyseId)
        this.modalService.open(this.viewModal, {ariaLabelledBy: 'modal-basic-title', size: 'xl'});
    }

    save(): void {
        if (this.form.valid) {
            const resultDTO: ResultDTO = {...this.form.value, client: {id: this.form.value.clientId}}
            this.resultService.save(resultDTO).subscribe({
                next: response => {
                    if (response.status) {
                        this.dataSource.data = [...this.dataSource.data, response.data];
                    }
                }, error: err => this.handleErrors.catchError(err),
                complete: () => {
                    this.form.reset();
                    this.modalService.dismissAll();
                    this.dialogService.openSuceessAlert('Result Added Successfully');
                }
            });

        } else {
            this.dialogService.open('Bad Request. Please Check Your Input and Submit Again!', environment.error_message_type, 'danger', environment.error_icon).finally();
        }
    }

    update() {
        if (this.editForm.valid) {
            const dto: ResultDTO = this.editForm.value;
            console.log('Objet DTO avant envoi:', dto);  // Affiche l'objet DTO avant de l'envoyer
    
            this.resultService.update(dto).subscribe({
                next: response => {
                    console.log('Réponse reçue du serveur:', response);  // Affiche la réponse du serveur
                    if (response.status) {
                        console.log('Mise à jour réussie, mise à jour de la ligne de tableau');
                        this.updateTableRow(response.data);
                        this.modalService.dismissAll();
                        this.dialogService.openSuceessAlert(response.message);
                    } else {
                        console.log('Erreur dans la réponse:', response.message);  // Affiche le message d'erreur
                        this.dialogService.open(response.message, environment.error_message_type, 'danger', environment.error_icon).finally();
                    }
                },
                error: err => {
                    console.error('Erreur lors de la mise à jour:', err);  // Affiche l'erreur dans la console
                    this.handleErrors.catchError(err);  // Gère les erreurs
                },
                complete: () => {
                    console.log('Opération terminée, réinitialisation du tri et de la pagination');  // Message de fin
                    this.initializePaginatorAndSort();  // Réinitialise le tri et la pagination
                }
            });
        } else {
            console.log('Formulaire invalide:', this.editForm.value);  // Affiche les valeurs du formulaire si invalide
            this.dialogService.open('Le formulaire est invalide. Veuillez vérifier les champs', environment.error_message_type, 'danger', environment.error_icon).finally();
        }
    }
    

    updateTableRow(updatedData: ResultDTO) {
        const index = this.dataSource.data.findIndex(item => item.id === updatedData.id);
        if (index !== -1) {
            this.dataSource.data[index] = updatedData;
            this.dataSource = new MatTableDataSource<ResultDTO>(this.dataSource.data);
        }
    }

    confirmDelete(id: number) {
        this.dialogService.open("Êtes-vous sûr de vouloir supprimer cet élément ?", environment.warning_message_type, 'danger', environment.warning_icon, true)
            .then((result: any) => {
                if (result) {
                    this.delete(id);
                }
            });
    }

    private delete(id: number) {
        this.resultService.delete(id).subscribe(
            {
                next: response => {
                    if (response.status) {
                        this.removeTableRow(id);
                        this.dialogService.openSuceessAlert("Résultat supprimé avec succés");

                    }
                }, error: err => this.handleErrors.catchError(err),
                complete: () => {
                }
            }
        );
    }

    removeTableRow(id: number) {
        this.dataSource.data = this.dataSource.data.filter(item => item.id !== id);
        this.dataSource = new MatTableDataSource<any>(this.dataSource.data);
    }

    applyFilter(event: Event) {
        ResultListComponent.searchValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
        this.dataSource.filter = ResultListComponent.searchValue
    }


    private fetchparameter(id: number): void {
        this.parameterService.getParameterByAnalyseId(id).subscribe({
          next: response => {
            this.parameter = response;  // Stocker les données du paramètre dans la variable
            console.log('Parameter Data:', this.parameter);  // Affichage dans la console
          },
          error: err => {
            console.error('Error fetching parameter:', err);  // Log en cas d'erreur
          }
        });
      }

    navigateInputs(event: KeyboardEvent, index: number, column: string): void {
        const columns = ['refAnalyse', 'poids', 'resultatBrute', 'resultatFinale', 'formule', 'dateMesure', 'valide', 'creationDate', 'updateDate']; // Add all columns with inputs here
        const columnIndex = columns.indexOf(column);

        switch (event.key) {
            case 'Enter':
            case 'ArrowDown':
                const nextRow = document.getElementById(`${column}${index + 1}`);
                if (nextRow) nextRow.focus();
                event.preventDefault();
                break;

            case 'ArrowUp':
                // Move to the input above, if it exists
                const previousRow = document.getElementById(`${column}${index - 1}`);
                if (previousRow) previousRow.focus();
                event.preventDefault();
                break;

            case 'ArrowRight':
                if (columnIndex < columns.length - 1) {
                    // Move to the next column in the same row
                    const nextColumn = document.getElementById(`${columns[columnIndex + 1]}${index}`);
                    if (nextColumn) nextColumn.focus();
                    event.preventDefault();
                }
                break;

            case 'ArrowLeft':
                if (columnIndex > 0) {
                    // Move to the previous column in the same row
                    const previousColumn = document.getElementById(`${columns[columnIndex - 1]}${index}`);
                    if (previousColumn) previousColumn.focus();
                    event.preventDefault();
                }
                break;
        }
    }


    fileData: any[] = []
    excelEvent: any | null = null;

    onExcelFileChange() {
        const target: DataTransfer = <DataTransfer>(this.excelEvent.target);
        if (target.files.length !== 1) {
            this.dialogService.openDangerDialog('Aucun données detecté')
            return
        }

        const reader: FileReader = new FileReader();
        reader.onload = (e: any) => {
            const binaryData = e.target.result;
            const workbook: XLSX.WorkBook = XLSX.read(binaryData, {type: 'binary'});

            const sheetName: string = workbook.SheetNames[0];
            const sheet: XLSX.WorkSheet = workbook.Sheets[sheetName];

            const data = XLSX.utils.sheet_to_json(sheet);
            this.fileData = data.map((row: any) => ({
                refAnalyse: row.refAnalyse.trim(),
                sampleCode: row.sampleCode,
                poids: row.poids,
                resultatBrute: row.resultatBrute,
                resultatFinal: row.resultatFinal
            }));
        };
        reader.readAsBinaryString(target.files[0]);

    }


    ex_event: any | null = null;
    btn_ImportFromExcelFile() {
        let data: ResultDTO[] = [];
        const target: DataTransfer = <DataTransfer>(this.ex_event.target);
    
        // Vérification du nombre de fichiers téléchargés
        if (target.files.length !== 1) {
            this.dialogService.openDangerDialog("Veuillez télécharger un seul fichier.");
            return;
        }
    
        const file = target.files[0];
        const reader: FileReader = new FileReader();
    
        // Ajout d'un log pour savoir quel fichier est sélectionné
        console.log('Fichier sélectionné:', file);
    
        reader.onload = (e: any) => {
            const binaryData = e.target.result;
            
            // Log du contenu binaire du fichier
            console.log('Données binaires lues:', binaryData);
    
            const workbook: XLSX.WorkBook = XLSX.read(binaryData, { type: 'binary' });
    
            // Log des feuilles du fichier Excel
            console.log('Feuilles du fichier Excel:', workbook.SheetNames);
    
            const sheetName: string = workbook.SheetNames[0];
            const sheet: XLSX.WorkSheet = workbook.Sheets[sheetName];
    
            // Log des données lues à partir de la première feuille
            console.log('Données de la première feuille:', XLSX.utils.sheet_to_json(sheet));
    
            data = XLSX.utils.sheet_to_json(sheet);
    
            // Log avant d'envoyer les données au service
            console.log('Données préparées pour l\'envoi au service:', data);
    
            this.resultService.updateResultfromExcel(data).subscribe({
                next: (response) => {
                    if (response.status) {
                        this.modalService.dismissAll();
                        this.dialogService.openSuccessDialog("Les résultats finaux ont été modifiés avec succès");
    
                        // Log de la réponse après succès
                        console.log('Réponse après mise à jour des résultats:', response);
    
                        this.dataSource.data = response.data;
                    } else {
                        console.log('Réponse échouée:', response);
                    }
                    this.ex_event = null;
                },
                error: err => {
                    this.modalService.dismissAll();
                    this.ex_event = null;
    
                    // Log des erreurs du service
                    console.error('Erreur lors de la mise à jour des résultats:', err);
                    this.handleErrors.catchError(err);
                }
            });
        };
    
        // Lecture du fichier comme chaîne binaire
        reader.readAsBinaryString(file);
    }
    

    event: any | null = null;

    btnUpdateFromText() {

        const input = this.event.target as HTMLInputElement;
        if (input.files && input.files[0]) {
            const file = input.files[0];
            const reader = new FileReader();

            reader.onload = () => {
                const text = reader.result as string;
                const dataFile = this.resultService.parseFileData(text)
                this.resultService.saveFromTextFile(dataFile)
                    .subscribe({
                        next: response => {
                            if (response.status) {
                                this.dataSource.data = response.data
                                this.modalService.dismissAll()
                            }
                        },
                        error: err => this.handleErrors.catchError(err)
                    })

            };
            reader.readAsText(file);

        }
    }

    btnExportResultsToExcel() {
        if (this.selectedItems.size == 0) {
            this.dialogService.openDangerDialog('Veuillez selectionner au moins une resultat!')
            return
        }

        const res : XslResultDTO[] = []
        for (let element of this.selectedItems){
            const xl : XslResultDTO = {...element}
            res.push(xl)
        }
        const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(res);

        const workbook: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Results');

        const excelBuffer: any = XLSX.write(workbook, {
            bookType: 'xlsx',
            type: 'array',
        });

        const data: Blob = new Blob([excelBuffer], {
            type: 'application/octet-stream',
        });
        saveAs(data, 'Results.xlsx');
        this.selectedItems = new Set<ResultDTO>()
        this.selectAll = false
    }

    calculerMultipleResult() {
        console.log("Début de la méthode calculerMultipleResult");
    
        if (this.editedItems.size == 0) {
            this.dialogService.openDangerDialog("Veuillez sélectionner au moins un résultat.");
            return;
        }
    
        const dtos: ResultDTO[] = [...this.editedItems];
    
        this.resultService.calculerMultipleResult(dtos).subscribe({
            next: response => {
                console.log("Réponse reçue du backend:", response);
    
                if (response.status) {
                    this.dataSource.data = response.data;
                    this.modalService.dismissAll();
    
                    let successMsg = "Les résultats finaux ont été mis à jour avec succès.";
                    if (response.warnings && response.warnings.length > 0) {
                        // Ajoute les warnings dans un message HTML
                        const warningHtml = response.warnings.map(w => `• ${w}`).join('<br>');
                        this.dialogService.openDangerDialog(successMsg +" "+ warningHtml);
                    } else {
                        this.dialogService.openSuccessDialog(successMsg);
                    }
                } else {
                    this.dialogService.openDangerDialog(response.message || "Erreur inconnue.");
                }
            },
            error: err => {
                this.handleErrors.catchError(err);
            },
            complete: () => {
                this.editedItems = new Set<ResultDTO>();
            }
        });
    }
    
    

    // Dans votre composant
getAllFormules() {
    this.resultService.getFormule().subscribe({
      next: formules => {
        console.log('Formules récupérées:', formules);
        this.formules = formules;  
        this.dataSource.data.forEach((element: any) => {
             const formule = formules.find((f: any) => f.id === element.formuleId);
          
          if (formule) {
            element.formule = formule.libelle;  // Exemple d'assignation d'une propriété, ajustez si nécessaire
          }
        });
      },
      error: err => {
        console.error('Erreur lors de la récupération des formules:', err);
      }
    });
  }
  

    addResult(element: ResultDTO) {
        this.editedItems.add(element)
        console.log(this.editedItems)
    }

    updateFormule(element: any): void {
        const index = this.formules.findIndex(f => f.formule === element.formule); // Comparaison basée sur la propriété 'formule'
              if (index !== -1) {
            this.formules[index].formule = element.formule;
            console.log('Formule mise à jour:', this.formules[index]);
        } else {
            console.log('Element non trouvé');
        }
    }
    
      
    updateDate(event: any) {
        const date = new Date(event);
        const formattedDate = date.toISOString(); // Convert to an ISO string
        this.editForm.get('dateMesure')?.setValue(formattedDate);
    }

    handleSelectAll() {
        this.selectAll = !this.selectAll
        if (this.selectAll) {
            this.selectedItems = new Set<ResultDTO>(this.dataSource.filteredData)
        } else {
            this.selectedItems = new Set<ResultDTO>()
        }
        console.log(this.selectedItems.size)
    }

    handleChecked(element: ResultDTO) {
        if (this.selectedItems.has(element)) {
            this.selectedItems.delete(element)
        } else {
            this.selectedItems.add(element)
        }

    }

    hideImportModel() {
        this.modalService.dismissAll()
    }

    btnAddFromText() {
        const input = this.event.target as HTMLInputElement;
        if (input.files && input.files[0]) {
            const file = input.files[0];
            const reader = new FileReader();

            reader.onload = () => {
                const text = reader.result as string;
                const dataFile = this.resultService.parseFileData(text)
                this.resultService.createFromTextFile(dataFile).subscribe({
                    next: () => {
                        this.fetchResults()
                    },
                    error: err => this.handleErrors.catchError(err)
                })

            };
            reader.readAsText(file);

        }
    }
}

export  interface XslResultDTO {
    id: number;

    poids : number;

    resultatBrute : number;

    resultatFinale : number;

    dateMesure: string;

    commentaire: string;

    valide: boolean;

    creationDate: string;

    updateDate: string;

    formule : string;
}
